/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Tenor
 */
export type TransferSelfRequestTenor = typeof TransferSelfRequestTenor[keyof typeof TransferSelfRequestTenor];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferSelfRequestTenor = {
  T0: 'T+0',
  T1: 'T+1',
  T2: 'T+2',
} as const;
